import { ToolBase, ToolDescription } from "../../../agents/base";
import { createTelemetry, resolveSessionId, unwrapRequest, } from "../readHelpers";
import { ReadChartsParamsSchema } from "./readCharts.schema";
const SYSTEM_PROMPT_DESCRIPTION = `### readCharts
Read authoritative chart payloads for XML edit cycles (chartXml/readId/version + chart image).`;
export function createReadChartsTool(runner, fallbackSessionId) {
    return new ReadChartsTool(runner, fallbackSessionId).toRuntimeToolDefinition();
}
export class ReadChartsTool extends ToolBase {
    constructor(runner, fallbackSessionId) {
        super();
        this.runner = runner;
        this.fallbackSessionId = fallbackSessionId;
        this.name = "readCharts";
        this.description = new ToolDescription("readCharts", "Read authoritative chart payloads for XML edit cycles.", ReadChartsParamsSchema);
        this.paramsSchema = ReadChartsParamsSchema;
        this.systemPromptDescription = SYSTEM_PROMPT_DESCRIPTION;
    }
    setSessionId(sessionId) {
        this.fallbackSessionId = sessionId;
    }
    async execute(args) {
        const startedAt = Date.now();
        const sessionId = resolveSessionId(args, this.fallbackSessionId);
        const request = unwrapRequest(args);
        const readCharts = request.readCharts || [];
        const result = await this.runner.read({ readCharts }, { sessionId });
        const payload = (result.data || {});
        const readChartsResult = payload.readCharts || [];
        return {
            ...result,
            data: { readCharts: readChartsResult },
            results: { readCharts: readChartsResult },
            telemetry: result.telemetry || createTelemetry(readCharts.length, startedAt),
        };
    }
}
